<template>
  <div class="base-table">
    <div class="base-table-table">
      <el-table
        ref="myTable"
        :data="tableList"
        style="width: 100%"
        stripe
        :cell-class-name="addClass"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" v-if="mulSelect"></el-table-column>
        <template v-for="(item, index) in tableHeader">
          <el-table-column v-if="item.label == '标签名称'" :label="item.label">
            <template slot-scope="scope">
              <div style="display: flex; flex-wrap: wrap; align-items: center">
                <div style="margin-bottom: 4px; margin-right: 10px">
                  <div
                    :style="{
                      color: `${scope.row[item.prop].textStyle}`,
                      backgroundColor: `${scope.row[item.prop].labelStyle}`,
                      padding: '0 4px 0 4px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                    }"
                  >
                    <img
                      v-if="scope.row[item.prop].labelIcon"
                      width="12px"
                      style="margin-right: 4px"
                      :src="
                        imgHost +
                        scope.row[item.prop].labelIcon.substring(
                          scope.row[item.prop].labelIcon.indexOf('jfs')
                        )
                      "
                      alt=""
                    />
                    {{ scope.row[item.prop].labelName }}
                  </div>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            v-else-if="item.label == '展示标签'"
            :label="item.label"
          >
            <template slot-scope="scope">
              <div style="display: flex; flex-wrap: wrap; align-items: center">
                <div
                  v-for="(item, index) in scope.row[item.prop]"
                  :key="index"
                  style="margin-bottom: 4px; margin-right: 10px"
                >
                  <div
                    :style="{
                      color: '#409EFF',
                      border: '1px solid #409EFF',
                      padding: '0 4px 0 4px',
                    }"
                  >
                    {{ item.labelName }}
                  </div>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            :prop="item.prop"
            :label="item.label"
            :align="'left'"
            :key="index"
            :width="item.width ? item.width : null"
            v-else
          >
            <template slot-scope="scope">
              <div>
                <p>{{ scope.row[item.prop] }}</p>
              </div>
            </template>
          </el-table-column>
        </template>
        <template v-if="tableType !== 0">
          <el-table-column
            justify="center"
            align="center"
            label="操作"
            :width="180"
          >
            <template slot-scope="scope">
              <el-button
                @click="handleClick(scope.row, 'edit')"
                type="text"
                size="small"
                >编辑</el-button
              >
              <span class="border"></span>
              <el-button
                type="text"
                size="small"
                @click="handleClick(scope.row, 'goAdmin')"
                >活动管理
              </el-button>
              <el-button
                type="text"
                size="small"
                @click="handleClick(scope.row, 'delete')"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </template>
      </el-table>
    </div>
  </div>
</template>

<script>
var env_mode = process.env.TYPE;
// import images from "../assets/";
export default {
  name: "circleTable",
  props: {
    tableData: {
      default: () => {
        return {
          tableList: Array, // 列表
          tableHeader: Array, // 表头
          tableType: Number, // 操作按钮
          shuType: Number,
        };
      },
    },
    isFreezeShow: {
      default: () => {
        return true;
      },
      type: Boolean,
    },
    activeName: {
      default: () => {
        return "";
      },
      type: String,
    },
    mulSelect: {
      default: () => {
        return false;
      },
      type: Boolean,
    },
  },
  // [ 'tableData' ],
  data() {
    return {
      images: "../assets/default-header.png",
      selectedRows: [],
      tableList: [],
      tableHeader: [],
      tableType: "",
      shuType: "",
      env_mode,
      dirt: {
        1: "图文",
        7: "视频",
        8: "疾病百科",
        9: "症状百科",
        11: "问答",
        13: "药品百科",
      },
      imgHost: process.env.VUE_APP_imgHost,
    };
  },
  mounted() {
    const $el = document.querySelectorAll(
      ".el-cascader-panel .el-cascader-node[aria-owns]"
    );
    Array.from($el).map((item) => item.removeAttribute("aria-owns"));
  },
  methods: {
    getHeadPic(row, key) {
      if (row.contentUser && row.contentUser[key]) {
        return `//image.healthjd.com/da/${row.contentUser[key]}`;
      } else {
        return "";
      }
    },
    getBriefing(row, key) {
      if (row.contentUser && row.contentUser[key]) {
        return row.contentUser[key];
      } else {
        return "";
      }
    },
    getCarryStatus(row) {
      /**
       * runStatus: 运行状态 1, "待执行" 2, "执行中" 3, "已完成"
       * resultStatus: 结果状态 1成功，0失败
       */
      if (row.runStatus === 3) {
        if (row.resultStatus === 1) {
          return "搬运成功";
        } else {
          return "搬运失败";
        }
      } else if (row.runStatus === 1) {
        return "待执行";
      } else if (row.runStatus === 2) {
        return "执行中";
      }
    },
    getContentType(row, key) {
      try {
        return this.dirt[row.taskRecordResult.contentBizDTO[key]] || "";
      } catch (error) {
        return "";
      }
    },
    getContent(row, key) {
      console.log(
        "🚀 ~ file: baseTable.vue:612 ~ getContent ~ row, key:",
        row,
        key
      );
      try {
        return row.taskRecordResult.contentBizDTO[key] || "未获取成功";
      } catch (error) {
        return "未获取成功";
      }
    },
    getContent2(row, key) {
      if (row.taskRecordResultDetail && row.taskRecordResultDetail.data) {
        try {
          const json = JSON.parse(row.taskRecordResultDetail.data);
          console.log(
            "🚀 ~ file: baseTable.vue:770 ~ getContent2 ~ json:",
            json
          );
          return json[key] || "未获取成功";
        } catch (error) {
          console.log(
            "🚀 ~ file: baseTable.vue:772 ~ getContent2 ~ error:",
            error
          );
          return "未获取成功";
        }
      } else {
        return "未获取成功";
      }
    },
    bianque_man(refName, index) {
      // let a = document.getElementsByClassName('.bianque')
      //
      // document.execCommand("copy")
      // document.body.removeChild(this.$refs[refName][index].innerText);
      // this.$message.success('复制成功')
      var aux = document.createElement("input");
      aux.setAttribute("value", this.$refs[refName][index].innerText);
      document.body.appendChild(aux);
      aux.select();
      document.execCommand("copy");
      document.body.removeChild(aux);
      this.$message.success("复制成功");
    },
    handleClick(val, type) {
      console.log("valvvvvvv", val, type);
      let data = {
        val,
        type: type,
      };
      this.$emit("handleClick", data);
    },
    cancelAdmin(val) {
      this.$emit("cancelAdmin", val);
    },
    addClass({ row, column, rowIndex, columnIndex }) {
      if (columnIndex == 1) {
        return "badge";
      }
    },
    changeNumToHan(num) {
      var arr1 = ["零", "一", "二", "三", "四", "五", "六", "七", "八", "九"];
      var arr2 = [
        "",
        "十",
        "百",
        "千",
        "万",
        "十",
        "百",
        "千",
        "亿",
        "十",
        "百",
        "千",
        "万",
        "十",
        "百",
        "千",
        "亿",
      ];
      if (!num || isNaN(num)) return "零";
      var english = num.toString().split("");
      var result = "";
      for (var i = 0; i < english.length; i++) {
        var des_i = english.length - 1 - i; // 倒序排列设值
        result = arr2[i] + result;
        var arr1_index = english[des_i];
        result = arr1[arr1_index] + result;
      }
      result = result.replace(/零(千|百|十)/g, "零").replace(/十零/g, "十"); // 将【零千、零百】换成【零】 【十零】换成【十】
      result = result.replace(/零+/g, "零"); // 合并中间多个零为一个零
      result = result.replace(/零亿/g, "亿").replace(/零万/g, "万"); // 将【零亿】换成【亿】【零万】换成【万】
      result = result.replace(/亿万/g, "亿"); // 将【亿万】换成【亿】
      result = result.replace(/零+$/, ""); // 移除末尾的零
      // 将【一十】换成【十】
      result = result.replace(/^一十/g, "十");
      return result;
    },
    handleSelectionChange(val) {
      this.selectedRows = val;
      this.$emit("selectedRows", val);
    },
    selectAllRows() {
      this.$refs.myTable.toggleAllSelection();
    },
  },
  created() {
    if (this.tableData) {
      var { tableList, tableHeader, tableType, shuType, general } =
        this.tableData;
      console.log("tableHeader", tableHeader);
    }
    this.tableList = tableList || [];
    this.tableHeader = tableHeader || [];
    this.tableType = tableType || 0;
    this.shuType = shuType;
  },

  filters: {
    dicCodeStatus: function (data) {
      switch (data) {
        case "12":
          return "抖音";
        case "13":
          return "快手";
        case "14":
          return "微博";
        case "15":
          return "b站";
        case "16":
          return "西瓜";
        default:
          return data;
      }
    },
    tenantStatus: function (data) {
      switch (data) {
        case 1:
          return "正常";
        case 2:
          return "已失效";
        default:
          return data;
      }
    },
    auditStatus: function (data) {
      switch (data) {
        case 0:
          return "未认证";
        case 1:
          return "待审核";
        case 2:
          return "通过";
        case 3:
          return "驳回";
        case 4:
          return "冻结";
        default:
          return data;
      }
    },
    isPin: function (data) {
      switch (data) {
        case 1:
          return "ERP账号";
        case 2:
          return "JD账号";
        case 3:
          return "其他账号";
        default:
          return data;
      }
    },
    isTenant: function (data) {
      switch (data) {
        case 1:
          return "内部租户";
        case 2:
          return "私域租户";
        case 3:
          return "非私域外部租户";
        default:
          return data;
      }
    },
    identity: function (data) {
      switch (data) {
        case 0:
          return "未知";
        case 1:
          return "写手";
        case 2:
          return "医护";
        case 3:
          return "运营";
        default:
          return data;
      }
    },
    articlesType: function (data) {
      switch (data) {
        case 1:
          return "图文";
        case 2:
          return "搭配";
        case 3:
          return "京装";
        case 4:
          return "帮助";
        case 5:
          return "单空间";
        case 6:
          return "整层";
        case 7:
          return "视频";
        case 8:
          return "疾病百科";
        case 9:
          return "症状百科";
        case 10:
          return "文章子文章";
        case 11:
          return "问答";
        case 15:
          return "回答";
      }
    },
  },
};
</script>

<style scoped lang="scss">
.httpLink {
  width: 152px;
  font-size: 12px;
  color: #5d6072;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.copy {
  display: flex;
  align-items: center;

  .but {
    width: 24px;
  }

  .httpLink {
    flex: 1;
  }
}

.images {
  width: 50px;
  height: 50px;

  // margin: 0 auto;
  & > img {
    border-radius: 50%;
    width: 100%;
    height: 100%;
  }
}

.badge {
  color: red;
}

.choiceness {
  color: #fff;
  background-color: red;
}

.noColor {
  color: #c0c4cc;
}

.cell {
  font-size: 13px;
  color: rgba(93, 96, 114, 1);
  overflow: visible !important;
}

// :deep(.el-button--text) {
//   color: #266CEE !important;
// }
</style>
